import axios from 'axios';

const API = axios.create({
  // Ye automatic .env se URL utha lega
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export default API;